import MainRoute from "../router/main-route";
import AppHeader from "../components/AppHeader";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
// import AppFooterMobile from "../components/AppFooterMobile";

const MainLayout = () => {
  const location = useLocation();
  const history = useHistory();

  return (
    <div className="wraper">
      <AppHeader pathName={location?.pathname} history={history} />
      <MainRoute />
      {/* <AppFooterMobile pathName={location?.pathname} /> */}
    </div>
  );
};

export default MainLayout;
